import { HStack, Text, IconButton, Image, useColorModeValue, Flex } from "@chakra-ui/react";
import React, { useContext } from "react";
import { FaSun, FaMoon, FaBars } from "react-icons/fa";
import { AppContext } from "../context/AppContext";
import Logo from '../assets/logo2.jpg';
import { useNavigate } from 'react-router-dom'
const Navbar = ({ onOpen }) => {
  const { toggleDark, isDark, balance } = useContext(AppContext);
  const navigate = useNavigate();
  // Premium Glassmorphism Styles
  const bg = useColorModeValue("rgba(255, 255, 255, 0.85)", "rgba(26, 32, 44, 0.85)");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const shadow = useColorModeValue("0 4px 30px rgba(0, 0, 0, 0.05)", "0 4px 30px rgba(0, 0, 0, 0.2)");
  const textColor = useColorModeValue("gray.800", "white");
  const balanceBg = useColorModeValue("gray.50", "whiteAlpha.200");
  const accentColor = useColorModeValue("brand.500", "brand.200");

  return (
    <Flex
      as="nav"
      position="sticky"
      top="0"
      zIndex="1000"
      w="100%"
      px={{ base: "1rem", md: "1.5rem" }}
      py="0.8rem"
      align="center"
      justify="space-between"
      bg={bg}
      backdropFilter="blur(16px)"
      borderBottom="1px solid"
      borderColor={borderColor}
      boxShadow={shadow}
      transition="all 0.3s ease"
    >
      {/* Left Section: Logo & Brand */}
      <HStack spacing={3}>
        <Image
          onClick={() => navigate('/')}
          rounded="full"
          src={Logo}
          w="3.5rem"
          h="3.5rem"
          // objectFit=""
          borderColor={accentColor}
          alt="Logo"
          shadow="sm"
        />
      </HStack>

      {/* Right Section: Balance, Theme, Menu */}
      <HStack spacing={2}>
        {/* Balance Pill */}
        <HStack
          bg={balanceBg}
          px="3"
          py="1.5"
          rounded="xl"
          border="1px solid"
          onClick={() => {
            navigate('/payment')
          }}
          borderColor={useColorModeValue("gray.100", "whiteAlpha.100")}
          boxShadow="sm"
        >
          <Text fontSize="0.85rem" fontWeight="bold" color="green.500">₹</Text>
          <Text fontSize="1rem" fontWeight="bold" color={textColor}>
            {Number(balance).toFixed(1)}
          </Text>
        </HStack>

        {/* Theme Toggle */}
        <IconButton
          size="md"
          isRound
          variant="ghost"
          icon={isDark ? <FaSun /> : <FaMoon />}
          onClick={toggleDark}
          aria-label="Toggle Theme"
          color={textColor}
          _hover={{ bg: useColorModeValue("gray.100", "whiteAlpha.200") }}
        />

        {/* Mobile Menu Trigger */}
        <IconButton
          icon={<FaBars />}
          variant="ghost"
          onClick={onOpen}
          aria-label="Open Menu"
          fontSize="1.3rem"
          color={textColor}
          _hover={{ bg: useColorModeValue("gray.100", "whiteAlpha.200") }}
        />
      </HStack>
    </Flex>
  );
};

export default Navbar;
